import { Injectable } from '@angular/core';
import { SelectItemGroup } from 'primeng/api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '../service/http.service';
import { Region } from '../region';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(
    private httpService: HttpService
  ) {}

   getRegions(): Observable<SelectItemGroup[]>{
    let itemGroups: SelectItemGroup[] = [];
    let regions = this.httpService.getRegions();
    return regions.pipe(map(regions => {
      for(let region of regions){
        itemGroups.push({
          label: region.name,
          items: this.setCountries(region)
        });
      };
      return itemGroups;
    }));
   }

   setCountries(region: Region){
     let items = [];
     for(let country of region.countries){
       items.push({
         label: country.name,
         value: country
       });
     }
     return items;
   }
}
